module.exports = __webpack_public_path__ + "img/home1.b8600fc1.png";